import Actions from 'actions';

const initialState = Object.freeze({});

function unattend(state = initialState, action) {
  switch (action.type) {
    case Actions.UNATTENDING_EVENT_REQUEST:
      return initialState;
    case Actions.UNATTENDING_EVENT_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.UNATTENDING_EVENT_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default unattend;
